"use client";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import FormFieldMapper from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper";
import { useCustomFormFilteredRows } from "@/components/site-builder/modules/CustomFormModule/hooks/useCustomFormFilteredRows";

export default function FormContent() {
  const rows = useCustomFormFilteredRows();

  return (
    <Stack spacing={2}>
      {rows.map((row, index) => (
        <Grid key={index} container rowSpacing={2} columnSpacing={2}>
          {row.columns.map((column) => (
            <Grid
              key={column.id}
              size={{ xs: 12, md: 12 / row.columns.length }}
            >
              <FormFieldMapper field={column} />
            </Grid>
          ))}
        </Grid>
      ))}
    </Stack>
  );
}
